import {
  IFormsData,
  IFormServer,
  IFormsMap,
  IRulesMap,
  IInfographicGridData,
  IDashboardDataMap,
  IActiveInfographicAnalytics,
  ISubmissionCountMap,
  ICustomPermission,
  IWorkflowMap,
} from "@common/redux/forms/interface";
import { IAdvancedRulesClient } from "../formBuilder/interface";
import { formsDataInitialState } from "./reducer";

export const fetchFormIdsSelector = (state: any): string[] => {
  return state?.forms?.formsData?.formIds || [];
};

export const fetchFormsMapSelector = (state: any): IFormsMap => {
  return state?.forms?.formsMap || {};
};

export const fetchRulesMapSelector = (state: any): IRulesMap => {
  return state?.forms?.rulesMap || {};
};
export const fetchWorkflowMapSelector = (state: any): IWorkflowMap => {
  return state?.forms?.workflowMap || {};
};
export const getActiveCustomPermissionSelector = (state: any): ICustomPermission => {
  return state?.forms?.customPermission || {};
};
export const fetchFormsMapByFormIdSelector = (
  state: any,
  formId: string
): IFormServer => {
  return state?.forms?.formsMap[formId] || {};
};

export const fetchFormsLoaderSelector = (state: any): boolean =>
  state?.forms?.loaders?.fetchForm;

export const fetchFormsErrorSelector = (state: any): string =>
  state?.forms?.error?.fetchForm || "";

export const getUpdateFormLoaderSelector = (state: any): boolean => {
  return state?.forms?.loaders?.updateForm || false;
};

export const getUpdateFormErrorSelector = (state: any): string => {
  return state?.forms?.errors?.updateForm || "";
};

export const getFormsDataSelector = (state: any): IFormsData => {
  return state?.forms?.formsData || formsDataInitialState;
};

export const getDeleteFormLoaderSelector = (state: any): boolean => {
  return state?.forms?.loaders?.deleteForm || false;
};

export const getDeleteFormErrorSelector = (state: any): string => {
  return state?.forms?.errors?.deleteForm || "";
};

export const getFetchFormByIdsLoaderSelector = (state: any): boolean => {
  return state?.forms?.loaders?.fetchFormByIds || false;
};

export const getTotalFormsSelector = (state: any): number => {
  return (state?.forms?.formsData?.totalForms ?? 0) + 1 || 0;
};

export const getCurrentPageFormsSelector = (state: any): number => {
  return state?.forms?.formsData?.pageNumber || 0;
};

export const getTotalPageInFormsSelector = (state: any): number => {
  return state?.forms?.formsData?.totalPages || 1;
};

export const getCreateRuleLoaderSelector = (state: any): boolean => {
  return !!state?.forms?.loaders?.createFormRules;
};

export const getCreateRuleErrorSelector = (state: any): string => {
  return state?.forms?.errors?.createFormRules || "";
};

export const getFormRule = (state: any): IAdvancedRulesClient => {
  return state?.forms?.rulesMap ?? {};
};
export const getFormRuleLoderSelector = (state: any): boolean => {
  return !!state?.forms?.loaders?.fetchFormRules;
};

export const getUpdateRuleLoaderSelector = (state: any): boolean => {
  return !!state?.forms?.loaders?.updateFormRules;
};

export const getUpdateRuleErrorSelector = (state: any): string => {
  return state?.forms?.errors?.updateFormRules || "";
};

export const getInfographicGridData = (state: any): IInfographicGridData => {
  return state?.forms?.infographicMap?.activeFormInfographic;
};

export const getInfographicsDashboardDataMapSelector = (
  state: any
): IDashboardDataMap => {
  return state?.forms?.dashboardDataMap || {};
};

export const getUpdateInfographicsLoaderSelector = (state: any): boolean => {
  return !!state?.forms?.loaders?.updateInfographicsDashBoardDataById;
};

export const getUpdateinfographicsErrorSelector = (state: any): string => {
  return state?.forms?.errors?.updateInfographicsDashBoardDataById || "";
};

export const getFetchInfographicsErrorSelector = (state: any): string => {
  return state?.forms?.errors?.fetchInfographicsDashBoardDataById || "";
};

export const getFormsAnalyticDataSelector = (
  state: any
): IActiveInfographicAnalytics => {
  return state?.forms?.infographicMap?.activeInfographicAnalytics || {};
};

export const getInforgraphicDataByQuerySelector = (state: any): any => {
  return state?.forms?.infographicMap?.activeInfographicDataByQuery;
};

export const getFormInfographicSelector = (state: any): any => {
  return state?.forms?.dashboardDataMap;
};

export const getDuplicateFormLoaderSelector = (state: any): boolean => {
  return !!state?.forms?.loaders?.duplicateForm;
};

export const getSubmissionCountMapSelector = (
  state: any
): ISubmissionCountMap => {
  return state?.forms?.submissionCountMap || {};
};

export const getFetchWorkflowLoaderSelector = (state: any): boolean => {
  return state?.forms?.loaders?.fetchWorkFlow || false;
};

export const getFetchworkflowErrorSelector = (state: any): string => {
  return state?.forms?.errors?.fetchWorkFlow || "";
};

